import React from 'react';
import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Container } from 'components/shared';
import { media } from 'styles';
import { sp, colors } from 'styles/theme';

const propTypes = {
  detail: PropTypes.arrayOf({}).isRequired,
  rightImage: PropTypes.bool.isRequired,
};

const StyledContainer = styled(Container)`
  img {
    padding-right: ${sp.l};
  }

  &:nth-child(odd) {
    img {
      padding-right: 0;
      padding-left: ${sp.l};
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${sp.xxl};

  ${media.tablet`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `};
`;

const ImageWrapper = styled.div`
  order: 1;

  ${media.tablet`
    order: inherit;
`};

  img {
    width: 100%;
    max-width: 500px;
  }
`;

const ContentWrapper = styled.div`
  order: 2;

  ${media.tablet`
    order: inherit;
  `};
`;

const Header = styled.h3`
  font-size: 2em;
`;

const List = styled.div`
  p,
  ul,
  ol {
    counter-reset: item;
    line-height: 1.4;
    font-weight: 400;
    margin-bottom: ${sp.xxl};
  }

  ol,
  ul {
    padding: 0;
    font-size: 20px;

    ${media.tablet`
      padding: 0 0 0 30px;
    `};
  }

  ul li {
    position: relative;
    list-style: none;
    padding-left: 40px;
    margin-bottom: ${sp.s};

    &::before {
      position: absolute;
      top: 15px;
      left: 0;
      width: 20px;
      height: 2px;
      background-color: ${colors.blue};
      content: '';
    }
  }

  ol li {
    position: relative;
    counter-increment: item;
    list-style: none;
    padding-left: 40px;
    margin-bottom: ${sp.s};

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: counters(item, '') '.';
      color: ${colors.blue};
      width: 20px;
    }
  }
`;

function Detail({ detail, rightImage }) {
  return (
    <StyledContainer>
      <Wrapper>
        {!rightImage && (
          <ImageWrapper>
            <img src={detail.sideImage.fullSize.src} alt="service" />
          </ImageWrapper>
        )}
        <ContentWrapper>
          <Header>{detail.headingText}</Header>
          <List>
            <ReactMarkdown
              source={detail.bodyText.bodyText}
              escapeHtml={false}
            />
          </List>
          <Button yellow to={detail.ctaLink}>
            {detail.ctaText}
          </Button>
        </ContentWrapper>
        {rightImage && (
          <ImageWrapper>
            <img src={detail.sideImage.fullSize.src} alt="service" />
          </ImageWrapper>
        )}
      </Wrapper>
    </StyledContainer>
  );
}

Detail.propTypes = propTypes;

export default Detail;



// WEBPACK FOOTER //
// ./src/components/HomePage/components/ServiceDetails/Detail.jsx